import e, { css as n } from "styled-components";
import s from "../Icons/Minus.js";
import a from "../Icons/Plus.js";
import t from "../../utils/colors.js";
const x = e.div``, m = e.div`
  border-bottom: 3px solid ${t.blueGrey10};
  ${({ $focused: o }) => o ? n`
          outline: 2px solid ${t.orange25};
          outline-offset: 2px;
        ` : ""}
`, r = n`
  padding: 24px 16px;
`, i = n`
  width: 15px;
  height: 15px;
  left: 0;
  position: absolute;
  transition: transform 0.3s, opacity 0.3s;
  box-sizing: content-box;

  &:before,
  &:after {
    box-sizing: content-box;
  }
`, c = e.button.attrs({ type: "button" })`
  width: 100%;
  border: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;

  :visited {
    outline: none;
  }

  :hover {
    cursor: pointer;
  }
`, l = e.div`
  ${r}
  padding-left: 0;
  font-family: 'VIC';
  width: 100%;
  text-align: left;
  color: ${t.blueGrey};
  font-size: 18px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
`, d = e.div`
  ${r}
`, p = e(a)`
  ${i}
`, $ = e(s)`
  ${i}
  transform: rotate(0);
`, v = e.div`
  ${i}
  position: relative;
`, y = e.div`
  ${c} {
    border-top: 3px solid ${(o) => o.$active ? t.orange : t.blueGrey10};
    background-color: ${(o) => o.$active ? t.orange10 : t.white};

    &:focus {
      outline: none;
      background-color: ${({ $active: o }) => o ? t.orange25 : t.blueGrey10};
    }
  }

  ${l} {
    color: ${(o) => o.$active && t.brown};
  }

  ${d} {
    color: ${t.blueGrey};
    opacity: ${(o) => o.$active ? "1" : "0"};
    max-height: ${(o) => o.$active ? "auto" : "0"};
    overflow: hidden;
    padding: ${(o) => o.$active ? "15px" : "0 15px"};
    transition: all 0.3s;
  }

  ${p} {
    transform: rotate(-90deg);
  }

  ${$} {
    transform: rotate(-180deg);
  }
  &[data-raised='true'] {
    z-index: 1000;
    position: sticky;
    background-color: ${t.white};
  }
`;
export {
  y as AccordionItem,
  m as Accordions,
  d as Content,
  c as Header,
  v as IconGroup,
  $ as IconMinus,
  p as IconPlus,
  l as Title,
  x as Wrapper
};
